module.exports = __webpack_public_path__ + "media/beats_of_water.99949c44.mp3";